import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
    loadOnboardDevicesOnlinePeers,
    selectOnboardDevicesOnlinePeers,
    selectOnboardDevicesOnlinePeersError,
    selectOnboardDevicesOnlinePeersLoading,
} from '../store/devices.reducer';
import { OnboardDevicesOnlineTableGrid } from '../Components/OnboardDevicesOnlineTableGrid';
import RefreshIcon from '@mui/icons-material/Refresh';

export const OnboardDevicesOnline = () => {
    const dispatch = useAppDispatch();

    const peersOnline = useAppSelector(selectOnboardDevicesOnlinePeers);
    const peersOnlineLoading = useAppSelector(selectOnboardDevicesOnlinePeersLoading);
    const peersOnlineError = useAppSelector(selectOnboardDevicesOnlinePeersError);

    useEffect(() => {
        dispatch(loadOnboardDevicesOnlinePeers());
    }, [dispatch]);

    const isEmptyState =
        peersOnline &&
        peersOnline.vpn_server_main.length === 0 &&
        peersOnline.vpn_server_secondary.length === 0;

    return (
        <Box sx={{ width: '100%', padding: '20px', height: '100vh' }}>
            <Box sx={{ marginBottom: 2 }}>
                <Button
                    startIcon={<RefreshIcon />}
                    color="primary"
                    onClick={() => dispatch(loadOnboardDevicesOnlinePeers())}
                    disabled={peersOnlineLoading}
                >
                    Reload
                </Button>
            </Box>

            {peersOnlineLoading && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 2 }}>
                    <CircularProgress size={20} />
                    <Typography>Loading online peers...</Typography>
                </Box>
            )}

            {peersOnlineError && (
                <Typography sx={{ marginBottom: 2 }} color="error">
                    Failed to load online peers: {peersOnlineError}
                </Typography>
            )}

            {isEmptyState && (
                <Typography sx={{ marginBottom: 2 }}>No active peers found on both VPN servers.</Typography>
            )}

            {peersOnline && !isEmptyState && <OnboardDevicesOnlineTableGrid peers={peersOnline} />}
        </Box>
    );
};
